import { Flex, Form, Select, Spacing } from '@approvalmax/ui/src/components';
import { FC, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { useGetTrackingFields } from '../../hooks/useGetTrackingFields';
import { cutsetName, exactConstraintIdName } from './TrackingCategoriesFormPart.constants';
import { getTrackingStaticItems } from './TrackingCategoriesFormPart.helpers';
import { messages } from './TrackingCategoriesFormPart.messages';
import { TrackingCategoriesFormPartProps } from './TrackingCategoriesFormPart.types';

const TrackingCategoriesFormPart: FC<TrackingCategoriesFormPartProps> = (props) => {
    const { companyId, budget } = props;

    const { data: fieldsData } = useGetTrackingFields(companyId);

    const formContext = useFormContext();

    const fields = useMemo(() => {
        return (fieldsData || []).map(({ exactValues, fieldId, name, ...restField }) => {
            const staticItems = getTrackingStaticItems(fieldId, name);
            const fieldItems = exactValues.map(({ fieldValueId, value }) => ({
                fieldId,
                [exactConstraintIdName]: fieldValueId,
                exactConstraintValue: value,
            }));

            return {
                ...restField,
                fieldId,
                name,
                items: [...staticItems, ...fieldItems],
            };
        });
    }, [fieldsData]);

    const handleChange =
        (index: number) =>
        <Items extends (typeof fields)[number]['items']>(value: Items[number]['exactConstraintId'], items: Items) => {
            formContext.setValue(
                `${cutsetName}.${index}`,
                items.find(({ exactConstraintId }) => exactConstraintId === value)
            );
        };

    const getDisabled = (fieldId: string) => {
        const field = budget?.constraints.find((targetField) => targetField.fieldId === fieldId);

        return Boolean(field?.value);
    };

    if (!fields.length) return null;

    return (
        <Form.Part>
            <Flex container>
                {fields.map(({ fieldId, items, name }, index) => (
                    <Flex size={12} key={fieldId}>
                        <Select
                            itemIdKey='exactConstraintId'
                            itemNameKey='exactConstraintValue'
                            name={`${cutsetName}.${index}.${exactConstraintIdName}`}
                            items={items}
                            placeholder={messages.cutsetPlaceholder({ name })}
                            label={name}
                            onChange={handleChange(index)}
                            required
                            disabled={getDisabled(fieldId)}
                        />
                    </Flex>
                ))}
            </Flex>

            <Spacing height={24} />
        </Form.Part>
    );
};

export default TrackingCategoriesFormPart;
